import React from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import XIconLoading from './PangoIconLoading'
import styled from 'styled-components'

type TFormBlocker = {
  children: React.ReactNode
  block?: boolean
}

const StyledIconWrapper = styled.div`
    display: flex;
    align-items: center;
    color: var(--primary-color);
    height: 80%;
    max-width: 6rem; /* 24 * 0.25rem */
    max-height: 6rem;
    aspect-ratio: 1 / 1;
`;

const Blocker = styled(motion.div)`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7); /* bg-white/70 */
    z-index: 50;
`;

export const FormBlocker = ({ children, block }: TFormBlocker) => {
  const variants = {
    open: { opacity: 1 },
    close: { opacity: 0 },
  }

  return (
    <>
      <AnimatePresence>
        {block && (
          <Blocker
            variants={variants}
            transition={{ duration: 0.1, delay: 0.1, ease: 'easeInOut' }}
            exit='close'
            initial='close'
            animate='open'
          >
            <StyledIconWrapper>
              <XIconLoading />
            </StyledIconWrapper>
          </Blocker>
        )}
      </AnimatePresence>
      {children}
    </>
  )
}
